import { CaseReducer, PayloadAction, createSlice } from "@reduxjs/toolkit";

import { ReceiptProvider } from "../../../../services";

interface State {
	loading: boolean;
	data: ReceiptProvider.Model[];
}

type Reducer<P> = CaseReducer<State, PayloadAction<P>>;

const initialState: State = {
	loading: false,
	data: [],
};

const setData: Reducer<State["data"]> = (state, { payload }) => {
	state.data = payload;
};

const setLoading: Reducer<boolean> = (state, { payload }) => {
	state.loading = payload;
};

const settingsReceiptProvider = createSlice({
	name: "settingsReceiptProvider",
	initialState,
	reducers: {
		setData,
		setLoading,
	},
});

export default settingsReceiptProvider;
